import React from 'react';
import { useSwipeToDelete } from '../hooks/useSwipeToDelete';
import './SwipeableRow.css';

/**
 * SwipeableRow component that wraps content and provides swipe-to-delete functionality
 * @param {Object} props Component props
 * @param {React.ReactNode} props.children Content to render inside the swipeable area
 * @param {Function} props.onDelete Callback when item is deleted
 * @param {string} props.deleteLabel Label to show in delete area (default: "Delete")
 * @param {boolean} props.disabled Disable swipe functionality
 * @param {string} props.className Additional CSS classes for the row
 */
function SwipeableRow({ 
  children, 
  onDelete, 
  deleteLabel = "Delete",
  disabled = false,
  className = ""
}) {
  const {
    swipeOffset,
    isSwiping,
    isDeleting,
    showDeleteHint,
    bindSwipeHandlers
  } = useSwipeToDelete({
    onDelete,
    threshold: 0.35,
    maxSwipe: 0.5,
    disabled
  });

  const handlers = bindSwipeHandlers();
  const { ref, ...touchHandlers } = handlers;

  return (
    <div 
      className={`swipeable-row ${isSwiping ? 'swiping' : ''} ${isDeleting ? 'deleting' : ''} ${className}`}
      ref={ref}
      {...touchHandlers}
    >
      {/* Delete action background */}
      <div className={`swipeable-row-delete-bg ${showDeleteHint ? 'active' : ''}`}>
        <span className="delete-label">🗑️ {deleteLabel}</span>
      </div>
      
      {/* Main content */}
      <div 
        className="swipeable-row-content"
        style={{
          transform: `translateX(${swipeOffset}px)`,
          transition: isSwiping ? 'none' : 'transform 0.2s ease-out'
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default SwipeableRow;
